module.exports = __webpack_public_path__ + "static/media/1POLICY6.efed0e97.jpg";